<div class="container section__congratulations h-full">
  <div class="wrapper">
    <div class="sectionContainer">
      <article class="pb-40">
        <div class="mainInfo mainInfo--full mainInfo--border">
          <div class="mainInfo__content">
            <div class="tag"><span>RETANQUEO</span><span class="circle"></span><span>CRÉDITO ACTIVO</span></div>
            <h1>¡Este cliente puede comprar hoy mismo en tu tienda!</h1>
            <p>Tiene un <strong>crédito activo</strong> con KrediYA, pero eso no es un obstáculo — tiene un nuevo crédito aprobado listo para usar.</p>
          </div>
        </div>

        <div class="creditInfo">
          <div class="title">
            <i><app-circle-wallet-icon></app-circle-wallet-icon></i>
            <h2>Lo que debes saber de este crédito:</h2>
          </div>

          <div class="msgAlert">
            <div class="msgAlert__title">
              <i><app-success-simple-icon></app-success-simple-icon></i>
              <h3>No debe cancelar su crédito vigente</h3>
            </div>
            <div class="msgAlert__description">
              <p>El saldo pendiente se incorpora automáticamente en el nuevo crédito.</p>
            </div>
          </div>

          <div class="steps">
            <div class="steps__content">
              <div class="steps__item">
                <span class="number">1</span>
                <div class="text">
                  <h4>Elige el nuevo producto</h4>
                  <p>El saldo pendiente se incorpora automáticamente en el nuevo crédito.</p>
                </div>
              </div>

              <div class="steps__item">
                <span class="number">2</span>
                <div class="text">
                  <h4>El sistema consolida los créditos</h4>
                  <p>Saldo anterior + nueva compra en una sola obligación.</p>
                </div>
              </div>

              <div class="steps__item">
                <span class="number">3</span>
                <div class="text">
                  <h4>Una cuota, un plazo</h4>
                  <p>El cliente no paga dos cuotas por separado.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Ver oferta de crédito" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="navigateToVerificationClient()"></button>
        </div>
      </footer>
    </div>
  </div>
</div>
